import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  useEffect(() => {
    const robots = document.head.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    const canonical = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    const ogUrl = document.head.querySelector('meta[property="og:url"]') as HTMLMetaElement | null;
    const alternates = [...document.head.querySelectorAll('link[rel="alternate"]')];
    const previousRobots = robots?.content;
    const previousCanonical = canonical?.href;
    const previousOgUrl = ogUrl?.content;
    const previousTitle = document.title;
    const activeRobots = robots || document.createElement("meta");

    activeRobots.name = "robots";
    activeRobots.content = "noindex, nofollow";
    if (!robots) document.head.appendChild(activeRobots);
    canonical?.remove();
    ogUrl?.remove();
    alternates.forEach((alternate) => alternate.remove());
    document.title = "Page Not Found | Fire Safety Singapore";

    return () => {
      if (robots) robots.content = previousRobots || "";
      if (!robots) activeRobots.remove();
      if (canonical && previousCanonical) {
        canonical.href = previousCanonical;
        document.head.appendChild(canonical);
      }
      if (ogUrl && previousOgUrl) {
        ogUrl.content = previousOgUrl;
        document.head.appendChild(ogUrl);
      }
      alternates.forEach((alternate) => document.head.appendChild(alternate));
      document.title = previousTitle;
    };
  }, [location.pathname]);
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">This page has not been generated</h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">Tell me more about this page, so I can generate it</p>
      </div>
    </div>
  );
}
